// ─── WORKWAVE DATA ────────────────────────────────────────────────────────────

export const JOBS = [
  { id:1,  title:"Senior Product Designer",  company:"Stripe",   logo:"S", color:"#6772e5", salary:"$145k–$185k", salaryMid:165000, location:"Remote",        type:"Full-time", remote:true,  match:94, tags:["Figma","Design Systems","User Research"], posted:"2h ago",  stage:null },
  { id:2,  title:"Design Systems Lead",      company:"Linear",   logo:"L", color:"#5E6AD2", salary:"$155k–$195k", salaryMid:175000, location:"Remote",        type:"Full-time", remote:true,  match:89, tags:["Design Systems","React","Tokens"],         posted:"4h ago",  stage:null },
  { id:3,  title:"UX Lead",                  company:"Notion",   logo:"N", color:"#444",    salary:"$130k–$165k", salaryMid:147000, location:"New York, NY",  type:"Full-time", remote:false, match:76, tags:["Figma","Research","Collaboration"],         posted:"1d ago",  stage:"Applied" },
  { id:4,  title:"Staff Designer",           company:"Vercel",   logo:"V", color:"#111",    salary:"$150k–$190k", salaryMid:170000, location:"Remote",        type:"Full-time", remote:true,  match:71, tags:["Leadership","Systems","Strategy"],          posted:"2d ago",  stage:"Interview" },
  { id:5,  title:"Product Designer II",      company:"Figma",    logo:"F", color:"#F24E1E", salary:"$120k–$155k", salaryMid:137000, location:"Remote",        type:"Full-time", remote:true,  match:82, tags:["Figma","Prototyping","Interaction"],        posted:"3h ago",  stage:null },
  { id:6,  title:"Head of Design",           company:"Loom",     logo:"L", color:"#625DF5", salary:"$200k–$240k", salaryMid:220000, location:"San Francisco", type:"Full-time", remote:false, match:68, tags:["Design Leadership","Brand","Strategy"],     posted:"5d ago",  stage:"Offer" },
  { id:7,  title:"UX Researcher",            company:"Figma",    logo:"F", color:"#F24E1E", salary:"$100k–$140k", salaryMid:120000, location:"Remote",        type:"Contract",  remote:true,  match:85, tags:["Research","Usability","SQL"],              posted:"6h ago",  stage:null },
  { id:8,  title:"Design Technologist",      company:"Stripe",   logo:"S", color:"#6772e5", salary:"$165k–$200k", salaryMid:182000, location:"Remote",        type:"Full-time", remote:true,  match:78, tags:["React","Figma","Design Systems"],           posted:"1d ago",  stage:null },
];

export const COMPANIES = [
  { id:1, name:"Stripe", logo:"S", color:"#6772e5", industry:"Fintech",    size:"4,000+",  rating:4.6, reviews:1284, ceoApproval:94, recommend:91, hiring:true,  salaryRating:4.8, cultureRating:4.5, growthRating:4.4, balanceRating:4.1 },
  { id:2, name:"Linear", logo:"L", color:"#5E6AD2", industry:"Dev Tools",  size:"90+",     rating:4.8, reviews:342,  ceoApproval:97, recommend:95, hiring:true,  salaryRating:4.7, cultureRating:4.9, growthRating:4.7, balanceRating:4.5 },
  { id:3, name:"Notion", logo:"N", color:"#444",    industry:"SaaS",       size:"700+",    rating:4.3, reviews:821,  ceoApproval:88, recommend:85, hiring:true,  salaryRating:4.3, cultureRating:4.5, growthRating:4.4, balanceRating:4.1 },
  { id:4, name:"Figma",  logo:"F", color:"#F24E1E", industry:"Design",     size:"1,200+",  rating:4.5, reviews:1102, ceoApproval:92, recommend:89, hiring:false, salaryRating:4.6, cultureRating:4.5, growthRating:4.2, balanceRating:4.0 },
  { id:5, name:"Vercel", logo:"V", color:"#111",    industry:"Dev Infra",  size:"500+",    rating:4.2, reviews:534,  ceoApproval:88, recommend:84, hiring:true,  salaryRating:4.4, cultureRating:4.3, growthRating:4.6, balanceRating:3.8 },
];

export const NETWORK = [
  { id:1, name:"Jordan Lee",  role:"Design Lead",     company:"Stripe", avatar:"#6772e5", initials:"JL", mutual:12, connected:true,  openToReferrals:true,  headline:"Building the future of payments UX" },
  { id:2, name:"Morgan Chen", role:"Staff Engineer",  company:"Linear", avatar:"#4ade80", initials:"MC", mutual:8,  connected:true,  openToReferrals:true,  headline:"Building fast software for fast teams" },
  { id:3, name:"Sam Torres",  role:"VP of Product",   company:"Notion", avatar:"#f5a623", initials:"ST", mutual:4,  connected:false, openToReferrals:false, headline:"Product leader · 0→1 builder" },
  { id:4, name:"Riley Park",  role:"Senior Designer", company:"Figma",  avatar:"#F24E1E", initials:"RP", mutual:17, connected:false, openToReferrals:true,  headline:"Crafting tools designers love" },
  { id:5, name:"Casey Wu",    role:"Eng Manager",     company:"Vercel", avatar:"#625DF5", initials:"CW", mutual:6,  connected:true,  openToReferrals:true,  headline:"Growing engineering teams at scale" },
];

export const MESSAGES_DATA = [
  { id:1, personId:1, preview:"Hey! Saw your checkout redesign work — exceptional.", time:"10:15", unread:true,
    thread:[
      { from:"them", text:"Hey! Saw your checkout redesign work — exceptional.", time:"10:02" },
      { from:"me",   text:"Thanks so much Jordan! Really proud of that one.", time:"10:15" },
      { from:"them", text:"We have a Lead Designer opening. Would you be interested?", time:"10:17" },
    ]
  },
  { id:2, personId:2, preview:"Your design systems work caught my eye.", time:"9:00", unread:false,
    thread:[
      { from:"them", text:"Morgan here from Linear. Love your design systems work. Would you be open to a quick chat?", time:"9:00" },
    ]
  },
  { id:3, personId:5, preview:"You: Hi Casey, reaching out because...", time:"Mar 10", unread:false,
    thread:[
      { from:"me", text:"Hi Casey, reaching out because I saw you manage design-eng relationships at Vercel. Would love to connect!", time:"Mar 10" },
    ]
  },
];

export const ALERTS = [
  { id:1, name:"Remote Design Roles",  active:true,  keywords:["Figma","Design Systems"], categories:["Design"], remote:"remote", salaryMin:120000, salaryMax:200000, frequency:"daily",   channels:["Email","In-App"] },
  { id:2, name:"All Design Opps",      active:true,  keywords:[], categories:["Design"],  remote:"any",    salaryMin:0,      salaryMax:0,      frequency:"weekly",  channels:["In-App"] },
  { id:3, name:"Stripe Watch",         active:false, keywords:[], categories:[],           remote:"any",    salaryMin:0,      salaryMax:0,      frequency:"instant", channels:["Email","Push"] },
];

export const PIPELINE_STAGES = [
  { stage:"Applied",     count:12, color:"#666"    },
  { stage:"Screened",    count:7,  color:"#5E6AD2" },
  { stage:"Interview",   count:4,  color:"#f5a623" },
  { stage:"Final Round", count:2,  color:"#fb923c" },
  { stage:"Offer",       count:1,  color:"#4ade80" },
];

export const WEEKLY_STATS = [
  { week:"Jan 27", applied:6, responses:3, interviews:1, offers:0 },
  { week:"Feb 3",  applied:7, responses:2, interviews:2, offers:0 },
  { week:"Feb 10", applied:4, responses:4, interviews:2, offers:1 },
  { week:"Feb 17", applied:8, responses:3, interviews:3, offers:1 },
  { week:"Feb 24", applied:5, responses:5, interviews:2, offers:2 },
  { week:"Mar 3",  applied:9, responses:4, interviews:4, offers:1 },
  { week:"Mar 10", applied:6, responses:6, interviews:3, offers:2 },
  { week:"Mar 14", applied:4, responses:3, interviews:5, offers:1 },
];

export const SALARY_BASES = {
  "Product Designer":       135000,
  "Senior Product Designer":162000,
  "Design Systems Lead":    182000,
  "Head of Design":         220000,
  "VP of Design":           270000,
  "Frontend Engineer":      145000,
  "Senior Frontend Engineer":178000,
  "Product Manager":        152000,
};

export const SALARY_LOC_MULT = {
  "San Francisco, CA": 1.0,
  "New York, NY":      0.97,
  "Seattle, WA":       0.95,
  "Remote (US)":       0.88,
  "Austin, TX":        0.82,
  "Los Angeles, CA":   0.90,
};

export const SALARY_EXP_MULT = {
  "Junior (0–2 yrs)":   0.68,
  "Mid (2–4 yrs)":      0.85,
  "Senior (4–7 yrs)":   1.0,
  "Staff (7–10 yrs)":   1.25,
  "Principal (10+ yrs)":1.5,
};

export const INTERVIEW_QUESTIONS = [
  { text:"Walk me through your most impactful design project.", type:"Portfolio", diff:"Easy" },
  { text:"How do you build a design system from scratch?",      type:"Systems",   diff:"Medium" },
  { text:"Tell me about a time you failed publicly and what you learned.", type:"Behavioral", diff:"Medium" },
  { text:"How do you balance user needs with business constraints?",        type:"Strategy",  diff:"Hard" },
  { text:"Design an onboarding flow for a solo-to-team transition.",        type:"Challenge", diff:"Hard" },
];

export const NAV_ITEMS = [
  { id:"home",      icon:"⌂",  label:"Home"       },
  { id:"jobs",      icon:"💼", label:"Jobs"        },
  { id:"companies", icon:"🏢", label:"Companies"   },
  { id:"network",   icon:"🤝", label:"Network"     },
  { id:"messages",  icon:"💬", label:"Messages",   badge:1 },
  { id:"alerts",    icon:"🔔", label:"Alerts",     badge:2 },
  { id:"analytics", icon:"📊", label:"Analytics"   },
  { id:"salary",    icon:"💰", label:"Salary"      },
  { id:"interview", icon:"🎯", label:"Interview"   },
  { id:"resume",    icon:"📄", label:"Resume"      },
  { id:"aimatching",  icon:"✦",  label:"AI Match"    },
  { id:"coverletter", icon:"✉️",  label:"Cover Letter"},
  { id:"profile",     icon:"👤", label:"My Profile"  },
];

export const STAGE_COLORS = {
  Applied:"#5E6AD2", Interview:"#f5a623",
  "Final Round":"#fb923c", Offer:"#4ade80", Rejected:"#f87171",
};
